import React from 'react'
import { Button, Dialog, DialogTitle, DialogContent, IconButton, Grid, Tooltip } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'

interface ButtonDialogProps {
	disabled?: boolean
	iconButton?: React.ReactNode
	title: string
	icon: React.ReactNode
	content: React.ReactNode
	actions?: React.ReactNode
	open: boolean
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default function ButtonDialog(props: ButtonDialogProps) {
	const { disabled, iconButton, title, icon, content, actions, open, setOpen } = props

	return (
		<>
			{iconButton ? (
				<Tooltip
					title={title?.split(' ')[0]}
					children={
						<span>
							<IconButton disabled={disabled} size='small' onClick={() => setOpen(true)}>
								{iconButton}
							</IconButton>
						</span>
					}
				/>
			) : (
				<Button
					sx={{ mb: 2, width: 150, ml: 2, fontSize: 11 }}
					disabled={disabled}
					variant='outlined'
					size='small'
					startIcon={icon}
					onClick={() => setOpen(true)}
				>
					{title}
				</Button>
			)}
			<Dialog fullWidth maxWidth='xs' open={open} onClose={() => setOpen(false)}>
				<DialogTitle>
					<Grid
						container
						alignItems='center'
						sx={{
							'.MuiSvgIcon-root': {
								mr: 1
							}
						}}
					>
						{icon}
						{title}
					</Grid>
				</DialogTitle>
				<DialogContent
					sx={{
						'& .MuiTextField-root': { width: '100%' },
						'& .MuiTypography-h5': { fontSize: 16 },
						'& .MuiBox-root': { mt: 1, mb: 0 }
					}}
				>
					{content}
				</DialogContent>
				{actions && <DialogActions>{actions}</DialogActions>}
			</Dialog>
		</>
	)
}
